<script>
import HomeUserInfo from '@/modules/home/components/HomeUserInfo.vue'
import IconNotice from '@/assets/images/ic_notice.svg'
export default {
   name: 'HomeNavbar',
   components: { HomeUserInfo },
   props: {
      activeFTTH: {
         type: Boolean,
         default: false
      },
      user: {
         type: Object,
         default: () => ({
            name: '',
            phone: '',
            avatarUrl: ''
         })
      },
      isLinkedFTTH: {
         type: Boolean,
         default: false
      }
   },
   emits: ['onClickMobileTab', 'onClickFTTHTab', 'redirectTo', 'onClickFunction', 'reload-user-info'],
   data() {
      return {
         IconNotice,
         dropdownOpen: false,
         selectedLang: null,
         languages: [
            { code: 'vi', name: 'Vietnam', flagUrl: './images/vn.svg' },
            { code: 'lo', name: 'Lao', flagUrl: './images/lo.svg' },
            { code: 'en', name: 'English', flagUrl: './images/en.svg' },
            { code: 'cn', name: 'Chinese', flagUrl: './images/cn.svg' }
         ]
      }
   },
   mounted() {
      // Lấy ngôn ngữ từ query param nếu có (ví dụ: ?language=vi)
      const langCodeFromParam = this.$route.query.language

      // Nếu có ngôn ngữ trong query, cập nhật localStorage và set ngôn ngữ cho i18n
      if (langCodeFromParam) {
         localStorage.setItem('language', langCodeFromParam) // Lưu vào localStorage để dùng lại sau
         this.$i18n.locale = langCodeFromParam // Cập nhật ngôn ngữ đang dùng trong app
      }

      // Ưu tiên lấy từ i18n (ngôn ngữ hiện tại), sau đó tới localStorage, nếu không có thì mặc định là 'vi'
      const langCode = this.$i18n.locale || localStorage.getItem('language') || 'vi'

      // Tìm object ngôn ngữ tương ứng từ danh sách ngôn ngữ
      const selectedLang = this.languages.find((l) => l.code === langCode)

      // Gán vào selectedLang để hiển thị cờ và tên ngôn ngữ trong UI
      if (selectedLang) {
         this.selectedLang = selectedLang
      }

      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      if (isIOS) {
         document.body.classList.add('is-ios')
      }
   },
   methods: {
      toggleDropdown() {
         console.log('Dropdown toggled')
         this.dropdownOpen = !this.dropdownOpen
      },

      selectLang(lang) {
         this.selectedLang = lang
         this.dropdownOpen = false

         // Cập nhật query trong route hiện tại
         this.$router.push({
            path: this.$route.path,
            query: {
               ...this.$route.query,
               language: lang.code
            }
         })
         setTimeout(() => {
            // Load lại trang sau khi push thành công
            window.location.reload()
         }, 100)
      }
   },
   created() {
      console.log('HomeNavbar created')

      const hash = window.location.hash // VD: #/home?originalUrl=#/ftth/payment-ftth
      const paramsString = hash.split('?')[1]
      // this.$emit('onClickFTTHTab'); // Gửi event chuyển tab FTTH
      // alert(paramsString);
      console.log('_________________________' + paramsString)

      if (paramsString) {
         const params = new URLSearchParams(paramsString)
         const redirectUrl = params.get('redirectUrl')
         console.log('_________________________' + redirectUrl)

         if (redirectUrl === '/ftth/change' || redirectUrl === '/ftth/renew-prepaid') {
            console.log('_________________________' + 'paramsString')

            setTimeout(() => {
               this.$emit('onClickFTTHTab') // Gửi event chuyển tab FTTH
            }, 1000)
         }
      }
   }
}
</script>

<template>
   <div id="nav-bar" class="nav-bar">
      <div class="nav-home">
         <div class="ios-sensitive-wrapper w-100 d-flex align-items-center justify-content-center position-relative">
            <div class="nav-switch mt-0 d-flex justify-content-center">
               <ul class="nav-switch__list">
                  <li :class="{ active: !activeFTTH }" class="nav-switch__item" @click="$emit('onClickMobileTab')">
                     Mobile
                  </li>
                  <li :class="{ active: activeFTTH }" class="nav-switch__item" @click="$emit('onClickFTTHTab')">
                     FTTH
                  </li>
               </ul>
            </div>

            <!-- Language selector tách ra khỏi luồng d-flex -->
            <div class="language-selector position-absolute" style="right: 0">
               <img v-if="selectedLang" :src="selectedLang.flagUrl" @click="toggleDropdown" class="flag" />
               <ul class="lang-dropdown" v-if="dropdownOpen">
                  <li v-for="lang in languages" :key="lang.code" @click="selectLang(lang)">
                     <img :src="lang.flagUrl" class="flag" /> {{ lang.name }}
                     <span class="tick" v-if="lang.code === selectedLang.code">
                        <img src="@/assets/images/t.svg" />
                     </span>
                  </li>
               </ul>
            </div>
         </div>
         <home-user-info
            :activeFTTH="activeFTTH"
            :isLinkedFTTH="isLinkedFTTH"
            :user="user"
            @onClickFunction="$emit('onClickFunction', $event)"
            @redirectTo="$emit('redirectTo', $event)"
            @show-account="(val) => $emit('show-account', val)"
            isShowMainAccountButton
         />
      </div>
   </div>
</template>

<style lang="scss" scoped>
.tick {
   position: absolute;
   right: 17px;
}
.language-selector {
   position: relative;
   font-family: sans-serif;
}

.lang-btn {
   width: 100%;
   background-color: white;
   border: 1px solid #ccc;
   padding: 10px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: space-between;
}

.ios-sensitive-wrapper {
  margin-top: 0;

  body.is-ios & {
    margin-top: 10px;
  }
} 

.flag {
   width: 34px;
   height: 34px;
   min-width: 34px;
   //   margin-right: 10px;
}

.lang-dropdown {
   list-style: none;
   padding: 0 10px;
   margin: 0;
   position: absolute;
   background-color: white;
   border: 1px solid #ccc;
   border-top: none;
   z-index: 999999999;
   right: -9px;
   width: 179px;
   border-radius: 10px;
}

.lang-dropdown li {
   padding: 10px 0px;
   display: flex;
   align-items: center;
   cursor: pointer;
   justify-content: flex-start;
   gap: 10px;
   /* margin: 10px; */
   border-bottom: 1px solid #ccc;
   position: relative;
}
.lang-dropdown li:last-child {
   border-bottom: none;
}

.lang-dropdown li:hover {
   background-color: #f0f0f0;
}

.nav-bar {
   position: relative;
   margin: 0;

   .nav-home {
      background: transparent;
      // padding-top: 52px;
      flex-direction: column;
      gap: 30px;
      // padding: 40px 20px 0px !important
   }

   .nav-switch {
      .nav-switch__list {
         height: 34px;
         background: rgba(187, 63, 7, 0.5);

         .nav-switch__item {
            width: 90px;
            height: 34px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 100px;
            font-size: 13px;
         }
      }
   }
}
</style>
